import { Permission } from '@today/types'
import type { ReactElement } from 'react'
import type { RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/components/RequirePermission'
import { ContentTypesPage } from './ContentTypesPage'
import { InboxPage } from './InboxPage'
import { TenantDefaultsPage } from './TenantDefaultsPage'
import { TextCreatePage } from './TextCreatePage'
import { TextEditorPage } from './TextEditorPage'
import { TextsListPage } from './TextsListPage'

/**
 * Content admin routes (TO-420 content-admin-ui REQ-001) — permission-gated;
 * without the permission the Forbidden page renders.
 */
const gated = (permission: Permission, element: ReactElement) => (
	<RequirePermission permission={permission}>{element}</RequirePermission>
)

/** Children of the app's `/` layout route. */
export const contentPageRoutes: RouteObject[] = [
	{ path: 'content/texts', element: gated(Permission.CONTENT_READ, <TextsListPage />) },
	{ path: 'content/texts/new', element: gated(Permission.CONTENT_WRITE, <TextCreatePage />) },
	{ path: 'content/texts/:id', element: gated(Permission.CONTENT_READ, <TextEditorPage />) },
	{ path: 'content/inbox', element: gated(Permission.CONTENT_APPROVE, <InboxPage />) },
	{ path: 'content/types', element: gated(Permission.CONTENT_TYPES_MANAGE, <ContentTypesPage />) },
	{ path: 'content/tenant-defaults', element: gated(Permission.CONTENT_READ, <TenantDefaultsPage />) },
]
